
















import { Component } from 'vue-property-decorator';
import Emoticons from '../../ScoreInput/Emoticons.vue';
import ClassCES from './ClassCES';

@Component({ components: { Emoticons } })
export default class ClassCES7Emoji extends ClassCES {}
